import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useContext, useState } from 'react';
export var AIAssistantContext = /*#__PURE__*/createContext({
  showAIAssistant: false,
  setShowAIAssistant: function setShowAIAssistant() {
    return null;
  }
});
export var AIAssistantProvider = function AIAssistantProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showAIAssistant = _useState2[0],
      setShowAIAssistant = _useState2[1];

  return /*#__PURE__*/React.createElement(AIAssistantContext.Provider, {
    value: {
      showAIAssistant: showAIAssistant,
      setShowAIAssistant: setShowAIAssistant
    }
  }, children);
};
export var useAIAssistant = function useAIAssistant() {
  var _useContext = useContext(AIAssistantContext),
      showAIAssistant = _useContext.showAIAssistant,
      setShowAIAssistant = _useContext.setShowAIAssistant;

  return {
    showAIAssistant: showAIAssistant,
    setShowAIAssistant: setShowAIAssistant
  };
};